import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import cx from 'classnames';
import PropTypes from 'prop-types';
import Check from '@material-ui/icons/Check';
import styles from './styles.module.sass';
import TableComponent from 'components/common/TableComponent/index';

const mapStateToProps = state => ({
  dicts: state.dictionary
});

@connect(mapStateToProps)
class CollectionCaseTable extends PureComponent {
  render() {
    const {
      onChangeSort,
      onChangeFilter,
      onClickRow,
      showFilter,
      items = [],
      dicts,
      filter = {},
      sort = {}
    } = this.props;

    // \u00A0shouldComponentUpdate
    return (
      <TableComponent
        getClassRow={(row, index) => cx(styles.row, {[styles.rowDark]: (index % 2 === 0)}, {[styles.rowIsOverdue]: row.isOverdue}, {[styles.rowIsOverdueDark]: row.isOverdue && (index % 2 === 0)} )}
        columns={[
          {field: 'finRequestNumber', name: 'Номер заявки', width: '60px'},
          {field: 'finRequestStateId', name: 'Статус кредита', width: '125px', dict: dicts.finRequestState},
          {field: 'borrowerName', name: 'Наименование заемщика', width: '200px'},
          {field: 'borrowerINN', name: 'ИНН заемщика', width: '100px'},
          {field: 'countDay', name: 'Текущий срок займа', width: '50px', widthIfShowFilter: '110px', type: 'number', filterType: 'range', format: (val, row) => {return (<div className={cx({[styles.valueIsOverdue]: row.isOverdue})}>{row.countDay}</div>);}},
          {field: 'creditDealStateId', name: 'Краткое описание', width: '125px', dict: dicts.creditDealState},
          {field: 'creditCaseSum', name: 'Сумма займа', width: '100px', type: 'money'},
          {field: 'creditCaseSumRemainder', name: 'Остаток по основному долгу', width: '100px', type: 'money'},
          //{hidden: true, field: 'percent', name: 'Начислено по % и пени', width: '85px', type: 'money'},
          {field: 'percentSumRemainder', name: 'Остаток по % и пени', width: '100px', type: 'money'},
          {field: 'issueDate', name: 'Дата выдачи', width: '70px', widthIfShowFilter: '140px', type: 'date'},
          {field: 'returnDate', name: 'Дата возврата', width: '70px', widthIfShowFilter: '140px', type: 'date'},
          {field: 'investorPhysicalPersonCount', name: 'Инве стор физ. лицо', width: '45px', widthIfShowFilter: '60px', type: 'number', format: (val) => val ? val : null, filterBy: 'investorPhysicalPersonExists', filterValueType: 'bool'},
          //{hidden: true, field: 'coCrediting', name: 'Сокред.', tooltip: 'Сокредитование', width: '45px', widthIfShowFilter: '60px', type: 'bool', format: (val) => val && <Check/> || ''},
          //{hidden: true, field: 'specialAccountId', name: 'Спец счет', width: '45px', widthIfShowFilter: '60px', type: 'bool', format: (val) => val && <Check/> || ''},
          {field: 'sendingMoneyTypeId', name: 'Отправка денег', width: '100px', dict: dicts.sendingMoneyType},
          {field: 'etpName', name: 'ЭТП', width: '200px'},
          {field: 'fz', name: 'ФЗ', width: '25px'},
          {field: 'tenderNumber', name: 'Номер закупки'},
          {field: 'borrowerPlaceAtAuction', name: 'Мес то', width: '35px'},
          {field: 'resultProtocolPublicationDate', name: 'Дата ППИ', width: '70px', widthIfShowFilter: '140px', type: 'date'},
          {field: 'denialProtocolPublicationDate', name: 'Дата протокола отказа', width: '70px', widthIfShowFilter: '140px', type: 'date'},
          {field: 'agentName', name: 'Наименование агента'},
          //{hidden: true, field: 'agentINN', name: 'ИНН агента', width: '100px'},
          {field: 'lastChangeDate', name: 'Дата обновления статуса', width: '70px', widthIfShowFilter: '140px', type: 'date'},
          {field: 'nextMonitoringDate', name: 'Дата следующего просмотра', width: '70px', widthIfShowFilter: '140px', type: 'date'},
          {field: 'collectionCaseStateId', name: 'Статус работы по взысканию', width: '150px', dict: dicts.collectionCaseState},
          {field: 'finRequestTypeId', name: 'Тип займа', width: '150px', dict: dicts.finRequestType},
        ]}
        items={items}
        showFilter={showFilter}
        filter={filter}
        sort={sort}
        onChangeSort={(srt) => onChangeSort(srt)}
        onChangeFilter={(flt) => onChangeFilter(flt)}
        onClickRow={onClickRow}
      />
    );
  }
}

CollectionCaseTable.defaultProps = {};

CollectionCaseTable.propTypes = {
  items: PropTypes.array.isRequired,
  filter: PropTypes.object,
  sort: PropTypes.object,
  showFilter: PropTypes.string,

  onChangeFilter: PropTypes.func.isRequired,
  onChangeSort: PropTypes.func.isRequired,
  onClickRow: PropTypes.func.isRequired,
};

export default CollectionCaseTable;


// WEBPACK FOOTER //
// ./src/components/page/CollectionCase/CollectionCaseTable/CollectionCaseTable.jsx